import api from "@/api/api-v2-config";

export async function getQuotationsListAxios() {    
    return await api.get("quotes");
}

export async function deleteQuotationsAxios(id) {    
    return await api.delete("quotes?Id=" + id);
}

export async function postQuotationsAxios(payload) {    
    return await api.post("quotes", payload);
}

export async function putQuotationsAxios(payload) {    
    return await api.put("quotes", payload);
}

export async function getQuotationByIdAxios(id) {    
    return await api.get("quotes/" + id);
}

export async function getQuotationDocumentList(ReferenceID) {
    return await api.get(`quotes/files?ReferenceID=${ReferenceID}&PageNumber=1&PageSize=10000`);
}

export async function deleteQuotationDocument(id) {
    return await api.delete("quotes/files/" + id);
}

export async function uploadQuotationDocument(file, referenceId, type, typeId) {
    console.log(file, referenceId);
    const formData = new FormData();
    formData.append('File', file[0]);
    formData.append('ReferenceId', referenceId);
    formData.append('type', type);
    formData.append('typeId', typeId);
    api.defaults.headers["Content-Type"] = "multipart/form-data";
    return await api.post('quotes/files/upload', formData);
}

export async function uploadQuotationMultipleDocuments(files, referenceId, type, typeId) {
    console.log(files, referenceId);
    const formData = new FormData();
    files.forEach(file => {
        formData.append('Files', file);
    });
    formData.append('ReferenceId', referenceId);
    formData.append('type', type);
    formData.append('typeId', typeId);
    api.defaults.headers["Content-Type"] = "multipart/form-data";
    return await api.post('quotes/files/uploads', formData);
}

export async function downloadQuotationDocument(id) {
    api.defaults.headers["responseType"] = "blob";
    return await api.get("quotes/files/download/" + id);
}